import templateAdmin from '../../../../Template/config/components/adminView'
import adminConfigManager from './AdminConfigManager'

export default {
  ...templateAdmin,
  adminConfigManager

}
